import { render, staticRenderFns } from "./CraeteItemTopic.vue?vue&type=template&id=2c21cc16"
import script from "./CraeteItemTopic.vue?vue&type=script&lang=js"
export * from "./CraeteItemTopic.vue?vue&type=script&lang=js"
import style0 from "./CraeteItemTopic.vue?vue&type=style&index=0&id=2c21cc16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports